import React, { useCallback } from 'react'
import { ContentType } from '../../types/trialLessons'
import CtaButton from '../../public/cta_button.png'

export type Props = {
  moveToId?: string
  bubbleLabel?: string
  label?: string
  isAB?: boolean
}

const ReservationMoveButton = ({
  moveToId = 'reservation-step-summary',
  bubbleLabel,
  label,
  isAB = false,
}: Props) => {
  const onClick = useCallback(() => {
    const moveTo = window.document
      .getElementById(moveToId)
      ?.getBoundingClientRect().top as number
    const scrollY = window.pageYOffset
    window.scroll({
      top: moveTo + scrollY,
      behavior: 'smooth',
    })
  }, [moveToId])

  if (isAB) {
    return (
      <button
        className="cursor-pointer mx-auto block relative max-w-full h-auto hover:opacity-80 px-4"
        onClick={onClick}
        type="button"
      >
        <img
          src={CtaButton.src}
          alt="日程を選択する"
          className="sm:w-1/2 h-auto block mx-auto"
        />
      </button>
    )
  }

  return (
    <button
      className="bg-[#C0506B] text-white flex items-center justify-center rounded cursor-pointer relative mx-auto my-10 desktop:w-[327px] h-[60px] desktop:hover:opacity-80 sp:w-[325px]"
      onClick={onClick}
      type="button"
    >
      <p className="text-white text-center font-bold text-[14px] leading-[20px] tracking-widest">
        {label || '日程を選択する'}
      </p>
      <div className="absolute m-auto top-0 bottom-0 right-[14px] flex items-center">
        <svg
          width="12"
          height="6"
          viewBox="0 0 12 6"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.99996 6L-5.24537e-07 1.04907e-06L12 0L5.99996 6Z"
            fill="white"
          />
        </svg>
      </div>
      <p className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white border-2 border-[#C0506B] rounded-[50px] px-5 py-[2px] font-bold text-[13px] leading-[20px] text-[#C0506B] whitespace-nowrap tracking-widest">
        {bubbleLabel || '人気のWEBスキル講座'}
      </p>
    </button>
  )
}

export default ReservationMoveButton
